import { memo, Suspense } from 'react'
import { useComponentSwitch } from '../../hooks/useComponentSwitch'

type HeaderProps = {
  contentRight?: React.ReactNode
  contentBottom?: React.ReactNode
  redirectLink?: string
}

export const TealHeader = memo<HeaderProps>((args) => {
  const Header = useComponentSwitch(
    () => import('./Header'),
    () => import('./Header'),
  )

  return (
    <Suspense fallback={null}>
      <Header {...args} />
    </Suspense>
  )
})

TealHeader.displayName = 'TealHeader'
